import React from "react";
import CountUp from "react-countup";

const Data = [
  {
    countNum: 40,
    countTitle: "Trusted Partners",
  },
  {
    countNum: 5000,
    countTitle: "Dedicated Hours",
  },
  {
    countNum: 6,
    countTitle: "Years in Industry",
  },
];
const CounterUpFour = ({ textAlign, counterStyle, column }) => {
  return (
    <div className="row">
      {Data.map((data, index) => (
        <div className={`${column}`} key={index}>
          <div className={`count-box ${counterStyle} ${textAlign}`}>
            <CountUp
              end={data.countNum}
              enableScrollSpy={true}
              scrollSpyDelay={200}
            >
              {({ countUpRef }) => (
                <div className="count-number">
                  <span ref={countUpRef} />
                </div>
              )}
            </CountUp>
            <h5 className="counter-title">{data.countTitle}</h5>
          </div>
        </div>
      ))}
    </div>
  );
};
export default CounterUpFour;
